import React from 'react';
import PropTypes from 'prop-types';

import themeable from 'zignal-landscape/lib/themeable';
import Card from 'zignal-landscape/lib/Card';
import Add3Icon from 'zignal-landscape/lib/Icon/Add3Icon';
import AnalyzeIcon from 'zignal-landscape/lib/Icon/AnalyzeIcon';

import Link from 'zignal-landscape/lib/Link';

const GetHelp = ({ styles }) => {
  return (
    <Card className={styles.CardContainer}>
      <div className={styles.HomeSubTitle}>
        Contact Support
      </div>
      <div className={styles.ButtonGroup}>
        <div className={styles.NewButton}>
          <Link
            href="https://zignallabs.freshdesk.com/support/tickets/new"
            icon={<Add3Icon />}
            displayType="button"
            target="_blank"
          >
            New Support Ticket
          </Link>
        </div>
        <div className={styles.CheckButton}>
          <Link
            href="https://zignallabs.freshdesk.com/support/tickets"
            icon={<AnalyzeIcon />}
            displayType="button"
            target="_blank"
          >
            Check Ticket Status
          </Link>
        </div>
      </div>
    </Card>
  );
};

GetHelp.propTypes = {
  styles: PropTypes.object.isRequired,
};

export default themeable(GetHelp);
